<template>
  <IndexPageSection
    v-if="showableEspeciallyRecommendSection"
    :need-link="false"
    :need-to-move-link-to-bottom="false"
    section-name="especially-recommend"
    :title="recommendTitle"
  >
    <div class="especially-recommend__lead">
      <span>{{ recommendDescription }}</span>
    </div>
    <a :href="recommendLinkUrl" @click="clickRecommendLinkUrl">
      <ImgLazy
        :image-url="ogpImage"
        :alt-text="ogpImageAlt"
        aspect-ratio="86 / 45"
        class="especially-recommend__ogp"
      />
    </a>
  </IndexPageSection>
</template>

<script>
import IndexPageSection from './IndexPageSection.vue'
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import dayjs from 'dayjs'

export default {
  components: { IndexPageSection, ImgLazy },
  data() {
    // 差し替え時は clickRecommendLinkUrl の announcement_id も変更すること。
    return {
      ogpImage:
        'https://static.giftee.com/master_data/images/announcement_thumbnails/425/Giftee_summergift-04 (1).png',
      ogpImageAlt: '夏のひんやりギフト',
      recommendTitle: '残りの夏も元気に過ごしてほしいから',
      recommendDescription: '帰省代わりのギフトや、残暑お見舞いに',
      recommendLinkUrl: '/announcements/425',
      showableEspeciallyRecommendSection: false,
      showableDate: '2024-08-18 23:59:59'
    }
  },
  mounted() {
    this.showableEspeciallyRecommendSection = dayjs().isSameOrBefore(
      this.showableDate
    )
  },
  methods: {
    clickRecommendLinkUrl() {
      dataLayer.push({
        event: 'select_top_area_promotion',
        announcement_id: '425'
      })
    }
  }
}
</script>

<!-- NOTE: IndexPageが現状グローバルCSS前提のため、ここも scoped を外す -->
<style lang="scss">
.especially-recommend {
  @extend %top-section;

  &__ogp {
    width: 100%;
    border-radius: 8px;
    border: 1px solid $gray-2;
  }

  &__container {
    @extend %top-section__container;
  }

  &__head {
    margin: 24px 0 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__title {
    @extend %top-section__title;
  }

  &__lead {
    @extend %top-section__lead;
  }
}

@media all and (min-width: ($sp-width + 1)) {
  .especially-recommend {
    display: none;
  }
}
</style>
